import React, { FC, useEffect } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { RouteComponentProps } from 'react-router'

import { clearExpiredCache } from '@/checkout-instore-legacy/cache/CacheCleaner'
import CookieHelper from '@/checkout-instore-legacy/utils/CookieHelper'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'
import {
  genericImportantEvent,
  genericImportantError,
} from '@/checkout-instore-legacy/utils/EventHelper'

export interface LoginRedirectSuccessProps {
  router: Record<string, any>
  vendor: Vendor
  store: Store
  loading: boolean
  readyToLoad: boolean
  loginRedirectTimeout: number
  loadInStoreVendor: (httpOnlyCookie: boolean) => void
}

type Props = RouteComponentProps<any, any> & LoginRedirectSuccessProps

const httpOnlyCookie = true

const LoginRedirectSuccess: FC<Props> = ({
  router,
  vendor,
  store,
  loading,
  loadInStoreVendor,
  loginRedirectTimeout,
  readyToLoad,
}) => {
  const vtexIdToken = CookieHelper.getVtexIdToken()
  const hasAuthenticated = !!vendor && !!store && !!vtexIdToken

  useEffect(
    function actionOnMountWhenAppIsReady() {
      if (readyToLoad) {
        loadInStoreVendor(httpOnlyCookie)
        clearExpiredCache()
        genericImportantEvent('login-redirect', { status: 'begin' })
      }
    },
    [readyToLoad, loadInStoreVendor]
  )

  useEffect(
    function ensureNotInfiniteLoading() {
      if (loginRedirectTimeout) {
        const timer = setTimeout(() => {
          genericImportantError('login-redirect', {
            status: 'end',
          })
          router.push('/')
        }, loginRedirectTimeout)

        return () => {
          clearTimeout(timer)
        }
      }

      return
    },
    [loginRedirectTimeout, router]
  )

  useEffect(
    function checkAuthenticationFinished() {
      if (hasAuthenticated) {
        genericImportantEvent('login-redirect', {
          status: 'end',
        })
        router.push('/')
      }
    },
    [hasAuthenticated, router]
  )

  return (
    <div className="flex flex-column vh-100 flex-auto items-center justify-center">
      <Loader loading={loading} />
    </div>
  )
}

LoginRedirectSuccess.defaultProps = {
  loading: true,
  readyToLoad: false,
  loginRedirectTimeout: 8000, // 8s
}

export default withRouter(LoginRedirectSuccess)
